import { all, takeLatest, put, call } from 'redux-saga/effects';
import Api from 'src/helpers/api';
import { sendRequest } from 'src/helpers/saga';
import { logger } from 'src/helpers/logger';
import notifications from 'src/redux/notifications/actions';
import { LoadDataRequestAction } from './actions.d';
import type { ILoadDataRequestPayload } from './types';
import actions from './actions';
import actionTypes from './actionTypes';

const api = new Api('pricing/engines');

export function* loadDataRequest({ payload }: LoadDataRequestAction): Generator<any, void, any> {
  try {
    // The payload is parsed straight off the URL, so `status` is dropped here rather than spread
    // into the request: the API has no engine-level status.
    const { filter, status: _status, ...rest } = payload as ILoadDataRequestPayload & { status?: unknown };
    const search = {
      ...rest,
      ...(filter ? { filter } : {}),
    };
    const result = yield call(sendRequest, api.load, { search }, notifications.REQUEST_ERROR);

    if (result?.status === 200 && result.data?.success?.data?.records) {
      const { records, totalCount, filteredCount, sortableColumns = [] } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          records,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
        }),
      );

      return;
    }

    yield put(actions.loadDataError());
  } catch (error) {
    logger.error(error);
    yield put(actions.loadDataError());
  }
}

// `takeLatest`, not `takeEvery`: the list re-requests per keystroke, and a superseded response
// landing late would overwrite fresher rows or clear `loadFailed` set by a newer request.
export default function* rootSaga() {
  yield all([takeLatest(actionTypes.LOAD_DATA_REQUEST, loadDataRequest)]);
}
